import { Stack, Typography } from '@mui/material'
import React from 'react'

const PageNotFound = (props) => {
  const { responsiveData } = props.breakPointsData;
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
    >
      <Typography sx={{ fontSize: `${parseFloat(responsiveData.fontSize) * 13}rem` }} variant="h1" >404</Typography>
      <Typography sx={{ fontSize: `${parseFloat(responsiveData.fontSize) * 1.6}rem` }} variant="subtitle1">Oops! Something is wrong</Typography>
    </Stack >
  )
}

export default PageNotFound